import { createSelector } from 'reselect'
import getInfoByIdVariantSelector from 'modules/variant/redux/selectors/get-info-by-id'

/**
 * @params {number} variantId
 */
const hasSubscriptionsVariantProductSelector = (variantId) => createSelector(
  getInfoByIdVariantSelector(variantId),
  /**
   * @param {GetProductVariantResp} variantInfo
   */
  variantInfo => {
    return !!variantInfo?.subscription_info?.is_available
  }
)

export default hasSubscriptionsVariantProductSelector
